import { getPublicCompressed } from '@toruslabs/eccrypto'
import axios from 'axios'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useWeb3Auth } from '../../../services/web3auth'
import useAuthStore from '../../../store/authStore'
import useUploadStore from '../../../store/uploadStore'
import MobileOverlay from './MobileOverlay'

const MobileTopBar = ({
  currentCategory,
  currentQuery,
  setSearchCategory,
  parent,
}: any) => {
  const [searchBox, setSearchBox] = useState(false)
  const [loader, setLoader] = useState<boolean>(true)
  const [saltBalance, setSaltBalance] = useState<any>()
  const [maticBalance, setMaticBalance] = useState<any>()
  const [walletAddress, setWalletAddress] = useState<string>('')
  const [categoryOpen, setCategoryOpen] = useState<boolean>(false)
  const router = useRouter()
  const { setActiveStep, setCurrentCategory, setUploadAssetId } =
    useUploadStore()

  const [active, setActive] = useState('')

  const user_id = useAuthStore((state) => state.userInfo)

  // For getting user verified
  const [secretKey, setSecretKey] = useState<any>()
  const [idToken, setIdToken] = useState<any>()
  const [typeOfLogin, setTypeOfLogin] = useState<any>()

  const { getCategoryList, categoryList } = useUploadStore()
  const { setCurrentUser, setOpenLogginDetails } = useAuthStore()
  const { logout } = useWeb3Auth()

  const [category, setCategory] = useState('All Categories')
  let [userName, setUserName] = useState<string>('')
  let [userProfileImage, setUserProfileImage] = useState<string>('')
  const [menu, setMenu] = useState(false)

  useEffect(() => {
    const path = router.route
    if (path === '/') setActive('discover')
    else setActive(path.slice(1).split('/')?.[0])
  }, [category, active, router])

  useEffect(() => {
    getCategoryList()
    if (walletAddress) return
    let x = setInterval(function () {
      setLoader(false)
    }, 4000)
    return () => clearInterval(x)
  }, [])

  const {
    provider,
    getAccounts,
    getMaticBalance,
    getPrivateKey,
    isLoading,
    metaMaskSign,
  } = useWeb3Auth()

  async function getCredentials() {
    setLoader(true)
    const wallet = await localStorage.getItem('WalletAddress')
    if (wallet !== null && wallet !== undefined) {
      setUserName(wallet)
      setLoader(false)
    }
    const crendetials = await localStorage.getItem('openlogin_store')
    if (crendetials !== null && crendetials !== undefined) {
      const user = JSON.parse(crendetials)
      setOpenLogginDetails(JSON.parse(crendetials))
      setIdToken(user.idToken)
      setTypeOfLogin(user.typeOfLogin)
    }
    setLoader(false)
  }

  useEffect(() => {
    if (provider) {
      if (
        !user_id ||
        user_id == undefined ||
        !walletAddress ||
        walletAddress == undefined
      )
        return
      const config = { user: { uid: user_id } }
      // console.log('config', config)
      axios
        .post(
          'https://us-central1-test-69192.cloudfunctions.net/userAuth/getWallet',
          config
        )
        .then((res) => {
          // const data = res?.data?.data?.data
          if (res?.data?.data?.salt) {
            setSaltBalance(res?.data?.data?.salt)
          } else {
            setSaltBalance(0)
          }
        })
        .catch((e) => {
          console.log(e)
        })

      Object.assign(config, { wallet_address: walletAddress })
      // console.log('Data is', config)
      if (typeOfLogin == 'jwt') {
        axios
          .post(
            'https://us-central1-test-69192.cloudfunctions.net/userAuth/updateWallet',
            config
          )
          .then((res) => console.log(res))
          .catch((e) => console.log(e?.response?.data?.message))
      }
    }
  }, [user_id, provider, walletAddress])

  useEffect(() => {
    if (provider) {
      getAccounts().then(() => {
        const address = localStorage.getItem('WalletAddress')
        if (address !== null && address !== undefined) {
          setWalletAddress(address)
          // console.log(walletAddress)
        }
      })
      if (walletAddress != '' && !isLoading && !loader) {
        getMaticBalance().then((data) =>
          setMaticBalance((data / 1e18).toFixed(2))
        )
      }

      const adapter = localStorage.getItem('Web3Auth-cachedAdapter')

      // TODO:
      if (adapter == 'wallet-connect-v1') {
        const walletConnect = localStorage.getItem('walletconnect')
        if (walletConnect !== null && walletConnect !== undefined) {
          // console.log('Hello there', walletConnect)
          // console.log('walletconnect login flow ')
          metaMaskSign()
            .then((data) => {
              const uid = data?.data?.data?.wallet?.address
              if (uid != undefined) {
                setCurrentUser(uid)
                localStorage.setItem('uid', uid)
              }
            })
            .catch((e) => {
              console.log(e)
            })

          localStorage.setItem('signature', '1')
        }
      }
      const isSigned = localStorage.getItem('signature')
      if (adapter == 'metamask' && isSigned == '0') {
        // console.log('metamask login flow ')
        metaMaskSign()
          .then((data) => {
            const uid = data?.data?.data?.wallet?.address

            if (uid != undefined) {
              setCurrentUser(uid)
              localStorage.setItem('uid', uid)
            }
          })
          .catch((e) => {
            // console.log(e)
          })

        localStorage.setItem('signature', '1')
      }

      if (typeOfLogin == 'discord') {
        // console.log('Only Discord Login goes here')
        // localStorage.setItem('uid', walletAddress)
        getPrivateKey().then((data) => {
          // console.log(data)
          setSecretKey(data)
        })

        let app_pub_key

        if (secretKey != undefined) {
          app_pub_key = getPublicCompressed(
            Buffer.from(secretKey.padStart(64, '0'), 'hex')
          ).toString('hex')
        }
        // console.log('secret key', secretKey)
        // console.log('app_pub_key', app_pub_key)

        const verifierData = {
          app_pub_key: app_pub_key,
          idToken: idToken,
          address: walletAddress,
          name: userName,
        }
        // console.log(verifierData)

        axios
          .post(
            'https://us-central1-test-69192.cloudfunctions.net/app/getverified-social',
            verifierData
          )
          .then((res) => {
            // console.log('response for discode', res)
            setCurrentUser(walletAddress)
            localStorage.setItem('uid', walletAddress)
          })
          .catch((e) => {
            // console.log(e)
          })
      }

      if (typeOfLogin == 'jwt' && localStorage.getItem('uid') === null) {
        const crendetials = localStorage.getItem('openlogin_store')
        if (crendetials !== null && crendetials !== undefined) {
          const user = JSON.parse(crendetials)
          // localStorage.setItem('uid', user.verifierId)
          const authToken = user.oAuthIdToken

          const config = {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
          const body = {
            idToken: authToken,
          }
          // console.log(config)
          axios
            .post(
              'https://us-central1-test-69192.cloudfunctions.net/app/valid',
              body,
              config
            )
            .then(async (res) => {
              // console.log('response', res)
              // console.log('result', JSON.parse(res.data.data.token))
              const result = JSON.parse(res.data.data.token)
              setCurrentUser(result.uid)
              localStorage.setItem('uid', result.uid)
            })
            .catch((e) => {
              console.log('error occured', e)
            })
        }
      }

      if (!userName || !userProfileImage) {
        getCredentials()
      }
    }
  }, [userName, loader, getAccounts, provider, walletAddress])

  const openMenu = (type: string) => {
    console.log(type)
    if (type === 'open') {
      setMenu(true)
      document.body.style.overflow = 'hidden'
    } else {
      setMenu(false)
      document.body.style.overflow = 'auto'
    }
  }

  return (
    <>
      <MobileOverlay menu={menu} openMenu={openMenu} />
      <div className="p-3 md:hidden" onClick={() => openMenu('open')}>
        <Image
          src="/icons/menu.svg"
          alt="menu"
          width={28}
          height={28}
          className="-rotate-6 -skew-x-12 transform invert"
        />
      </div>
    </>
  )
}
export default MobileTopBar
